export enum Consent {
  Advertising = 'advertising',
  Performance = 'performance',
  Targeting = 'targeting',
}
